





import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

@Component({
})
export default class JdhPageSectionNarrow extends Vue {
    @ActiveProvide('jds.breakdown.stack') breakdownStack = true;
    @ActiveProvide('jds.page.section-heading.small') smallHeadings = true;
    @ActiveProvide('jds.button.size') buttonSize: string = 'low';
}
